import { request } from '@/utils/request';
import ENDPOINT from "@/config/endpoint";


function listSettings(params) {
  return request({
    url: ENDPOINT.SETTINGS_BACKEND,
    method: 'get',
    params
  });
}

export default {
  listSettings,
};